"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodeTransformationStage = void 0;
var CodeTransformationStage;
(function (CodeTransformationStage) {
    CodeTransformationStage["PreparingTransformers"] = "PreparingTransformers";
    CodeTransformationStage["FinalizingTransformers"] = "FinalizingTransformers";
})(CodeTransformationStage || (exports.CodeTransformationStage = CodeTransformationStage = {}));
